module.exports = __webpack_public_path__ + "static/media/login-google.88e5892d.svg";